:root {
  --offcanvas-width: 480px;
}

.smart-quote-disclaimer {
  margin-top: 56px;
  z-index: 1000 !important;
  width: var(--offcanvas-width) !important;
}

.smart-quote-ws {
  transition: padding-right 0.1s ease-in-out;
}

main.smart-quote-ws {
  transition: padding-right 0.1s ease-in-out;
}

@media (min-width: 1440px) {
  body:has(.offcanvas.show) main.smart-quote-ws {
    padding-right: var(--offcanvas-width);
  }
}

@media (max-width: 1439px) {
  main.smart-quote-ws {
    padding-right: 0;
  }
}

@media (max-width: 960px) {
  .smart-quote-disclaimer {
    width: 100% !important;
    border: 0;
  }
}
